import { useContext, useEffect } from "react";

import { useParams } from "react-router-dom";
import { getPolicyRiskSettings } from "../../../redux/actions/policies";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
    Policy,
    RiskSettings,
} from "../../../redux/reducers/types/commonTypes";
import { DashboardContext } from "../../components/contexts/DashboardContext";
import PolicyExtensionSettings from "../../components/policies/settings/PolicyExtensionSettings";
import PolicyMemebershipSettings from "../../components/policies/settings/PolicyMembershipSettings";
import PolicyUnderwritingSettings from "../../components/policies/settings/PolicyUnderwritingSettings";
import MobileResponsiveWarningModal from "../../components/policies/utils/MobileResponsiveWarningModal";


export default function PolicySettings() {
    let { id } = useParams();
    const dispatch = useAppDispatch();
    const { setPageTitle } = useContext(DashboardContext);

    let publicPolicies: Policy[] = useAppSelector(
        (state) => state.policies.publicPolicies
    );
    const policy: Policy =
        publicPolicies.find((p: Policy) => p.id === parseInt(id || "")) ||
        ({} as Policy);

    const riskSettings: RiskSettings = useAppSelector(
        (state) => state.risk.policyRiskSettings?.[policy?.id]
    );

    useEffect(() => {
        if (riskSettings === undefined) {
            dispatch(getPolicyRiskSettings(policy?.id));
        }
    }, [policy?.id]);

    useEffect(() => {
        setPageTitle("Policy Settings");
    }, []);

    if (!policy || !riskSettings) {
        return <div>Policy Not Found</div>;
    }

    return (
        <div>
            <PolicyUnderwritingSettings policy={policy} />

            <PolicyExtensionSettings policy={policy} />
            <PolicyMemebershipSettings policy={policy} />
            {/* <Divider />
            <PolicyDangerZone policy={policy} /> */}

            <MobileResponsiveWarningModal />
        </div>
    );
}
